import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ChargifyActivateComponent }             from './chargify.activate.component';
import { ChargifyExportCancelationsComponent }   from './chargify.export-cancelations.component';
import { ChargifyService }                       from './chargify.service';
import { ChargifySubscriptionControlComponent }  from './chargify.subscription-control.component';
import { ChargifyTrailMessageComponent }         from './chargify.trail-message.component';
import { SharedModule }                          from '../shared/shared.module';

@NgModule({
  declarations: [
    ChargifyActivateComponent,
    ChargifyExportCancelationsComponent,
    ChargifySubscriptionControlComponent,
    ChargifyTrailMessageComponent
  ],
  entryComponents: [
    ChargifyActivateComponent,
    ChargifyExportCancelationsComponent,
    ChargifySubscriptionControlComponent,
    ChargifyTrailMessageComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ChargifyService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class ChargifyModule {}
